import React from "react";
import { makeStyles, Tooltip, Box, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  wrap: {
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing(1)}px ${theme.spacing(1.5)}px`,
    borderRadius: 8,
    color: "#fff",
    minWidth: 70,
    cursor: "default",
  },
  score: {
    fontWeight: 700,
    fontSize: "1.1rem",
    lineHeight: 1,
  },
  label: {
    fontSize: "0.65rem",
    textTransform: "uppercase",
    letterSpacing: 0.5,
    marginTop: 2,
    opacity: 0.9,
  },
}));

const colorFor = (score) => {
  if (score >= 80) return "#2e7d32";
  if (score >= 60) return "#558b2f";
  if (score >= 40) return "#f9a825";
  if (score >= 20) return "#ef6c00";
  return "#9e9e9e";
};

const MatchScore = ({ score, matched, missing, experienceMet }) => {
  const classes = useStyles();
  if (score === null || score === undefined) return null;

  const tooltipContent = (
    <Box>
      <Typography variant="caption" style={{ display: "block", fontWeight: 600 }}>
        AI Match: {score}%
      </Typography>
      {matched && matched.length > 0 && (
        <Typography variant="caption" style={{ display: "block" }}>
          Matched: {matched.join(", ")}
        </Typography>
      )}
      {missing && missing.length > 0 && (
        <Typography variant="caption" style={{ display: "block" }}>
          Missing: {missing.join(", ")}
        </Typography>
      )}
      {!experienceMet && (
        <Typography variant="caption" style={{ display: "block" }}>
          Experience below target
        </Typography>
      )}
    </Box>
  );

  return (
    <Tooltip title={tooltipContent} arrow>
      <div className={classes.wrap} style={{ background: colorFor(score) }}>
        <span className={classes.score}>{score}%</span>
        <span className={classes.label}>AI Match</span>
      </div>
    </Tooltip>
  );
};

export default MatchScore;
